import * as React from "react";
import { styled } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import IconButton from "@mui/material/IconButton";

//region [[ Styles ]]

const PatientCardNavView = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 5,
  fontSize: 14,
  fontWeight: "normal",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientCardNavProps {
  patientIndex: number;
  totalCount: number;
  onGotoIndex: (index: number) => void;
  loading: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientCardNav = ({
  patientIndex,
  totalCount,
  loading,
  onGotoIndex,
}: PatientCardNavProps) => {
  if (loading || !totalCount) return <PatientCardNavView></PatientCardNavView>;

  return (
    <PatientCardNavView>
      <IconButton
        onClick={() => onGotoIndex(patientIndex - 1)}
        size={"small"}
        disabled={patientIndex === 0}
      >
        <NavigateBeforeIcon />
      </IconButton>
      {patientIndex + 1} of {totalCount}
      <IconButton
        onClick={() => onGotoIndex(patientIndex + 1)}
        size={"small"}
        disabled={patientIndex === totalCount - 1}
      >
        <NavigateNextIcon />
      </IconButton>
    </PatientCardNavView>
  );
};
